<script>
import { deleteBooking } from "../../../api/services/booking.service";
export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
    booking: Object,
  },
  data() {
    return {
      bookingId: null,
      bookingTitle: null,
      type: null,
      startTime: null,
      endTime: null,
      bookingNote: null,
      status: null,
      reserverName: null,
      reserverEmail: null,
      reserverTelephone: null,
      deleteBookingSuccess: false,
      deleteBookingFailed: false,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {
    if (this.booking) {
      this.bookingId = this.booking.bookingId;
      this.bookingTitle = this.booking.bookingTitle;
      this.type = this.booking.type;
      this.startTime = new Date(this.booking.startTime);
      this.endTime = new Date(this.booking.endTime);
      this.bookingNote = this.booking.bookingNote;
      this.status = this.booking.status;
      this.reserverName = this.booking.reserverName;
      this.reserverEmail = this.booking.reserverEmail;
      this.reserverTelephone = this.booking.reserverTelephone;
    }
  },
  methods: {
    clickCloseButton() {
      this.$emit("close");
    },
    async clickDeleteBookingButton() {
      let deleteServiceBookingSuccess = await deleteBooking(this.bookingId);
      if (deleteServiceBookingSuccess) {
        this.deleteBookingSuccess = true;
        this.$emit("reload");
      } else {
        this.deleteBookingFailed = true;
      }
    },
  },
};
</script>

<template>
  <!-- Edit Event Model Model -->
  <b-modal
    v-model="showModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    header-close-content
    scrollable
  >
    <div class="row mt-3 justify-content-center">
      <div class="col-md-12 mb-3">
        <h5>{{ $t("booking.editBooking.title") }}</h5>
      </div>
      <!-- Edit Sucees and Failed Msg -->
      <div class="col-md-12 mb-3">
        <b-alert v-model="deleteBookingSuccess" variant="success" dismissible
          ><i class="mdi mdi-check-all mr-2"></i
          >{{ $t("booking.editBooking.bookingDeleteSuccess") }}</b-alert
        >
        <b-alert v-model="deleteBookingFailed" variant="danger" dismissible
          ><i class="mdi mdi-check-all mr-2"></i
          >{{ $t("booking.editBooking.bookingEditFailed") }}</b-alert
        >
      </div>
      <!-- booking title -->
      <div class="col-md-6">
        <label>
          <i class="bx bx-notification font-size-16 align-middle mr-1"></i
          >{{ $t("booking.editBooking.bookingTitle") }}:
        </label>
      </div>
      <div class="col-md-6">
        {{ this.bookingTitle }}
      </div>
      <!-- booking Start Date -->
      <div class="col-md-6">
        <label>
          <i class="bx bx-calendar-alt font-size-16 align-middle mr-1"></i>
          {{ $t("booking.editBooking.bookinStartDateAndTime") }}:
        </label>
      </div>
      <div class="col-md-6">
        {{ this.startTime.toString().slice(0, 15) }} am
        {{ this.startTime.getHours() }}:{{ this.startTime.getMinutes() }}
      </div>
      <!-- booking End Date -->
      <div class="col-md-6">
        <label>
          <i class="bx bx-calendar-alt font-size-16 align-middle mr-1"></i>
          {{ $t("booking.editBooking.bookinEndDateAndTime") }}:
        </label>
      </div>
      <div class="col-md-6">
        {{ this.endTime.toString().slice(0, 15) }} am
        {{ this.endTime.getHours() }}:{{ this.endTime.getMinutes() }}
      </div>
      <div class="col-md-12 border-top mt-3 mb-3"></div>
      <!-- booking Name -->
      <div class="col-md-4">
        <label>
          <i class="bx bx-user font-size-16 align-middle mr-1"></i>
          {{ $t("booking.editBooking.bookingReserverName") }}:
        </label>
      </div>
      <div class="col-md-8">
        {{ this.reserverName }}
      </div>
      <!-- booking Email -->
      <div class="col-md-4">
        <label>
          <i class="bx bx-envelope font-size-16 align-middle mr-1"></i
          >{{ $t("booking.editBooking.bookingReserverEmail") }}:
        </label>
      </div>
      <div class="col-md-8">
        {{ this.reserverEmail }}
      </div>
      <!-- booking Telephone -->
      <div class="col-md-4">
        <label>
          <i class="bx bx-phone font-size-16 align-middle mr-1"></i
          >{{ $t("booking.editBooking.bookingReserverTelephone") }}:
        </label>
      </div>
      <div class="col-md-8">
        {{ this.reserverTelephone }}
      </div>
      <div class="col-md-12 border-top mt-3 mb-3"></div>
      <!-- booking Note -->
      <div class="col-md-12">
        <label>
          <i class="bx bx-note font-size-16 align-middle mr-1"></i>
          {{ $t("booking.editBooking.bookingNote") }}:
        </label>
      </div>
      <div class="col-md-12">
        {{ this.bookingNote }}
      </div>
    </div>
    <!-- Action -->
    <div class="row mt-5">
      <div class="col-md-12">
        <b-button
          class="mr-2"
          variant="danger"
          @click="clickDeleteBookingButton()"
        >
          <i class="bx bxs-trash mr-1"></i>
          {{ $t("general.buttons.delete") }}</b-button
        >
        <b-button variant="light" @click="clickCloseButton()">
          <i class="bx bx-x mr-1"></i>
          {{ $t("general.buttons.cancel") }}</b-button
        >
      </div>
    </div>
  </b-modal>
</template>
